export default __webpack_public_path__ + "static/managed-solutions-billboard-a0df76a76da95c869fccfaf6640a6c3e.svg";